<div class="modal-header text-large" [innerHtml]="title"></div>
<div class="modal-body p-3" [innerHtml]="body"></div>
<div class="modal-footer">
  <button class="btn btn-sm btn-blank text-secondary" (click)="activeModal.dismiss()" [innerHtml]="buttonTextCancel"></button>
  <button class="btn btn-sm btn-blank" (click)="activeModal.close()" [innerHtml]="buttonTextOk"></button>
</div>
